module.exports = __webpack_public_path__ + "img/login_bg.4b181531.jpeg";